"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveUrl = void 0;
var compute_current_zone_1 = require("./compute-current-zone");
var constants_1 = require("./constants");
var resolveUrl = function (url, zone) {
    if (url === void 0) { url = ''; }
    if (zone === void 0) { zone = compute_current_zone_1.currentZone; }
    var replacements = constants_1.replacementsByZone[zone] || constants_1.replacementsByZone[constants_1.defaultZone];
    var orderedReplacements = constants_1.orderedReplacementsByZone[zone] || constants_1.orderedReplacementsByZone[constants_1.defaultZone];
    if (!url || !replacements || !orderedReplacements) {
        return url;
    }
    var regexStr = orderedReplacements.join('|');
    var regex = new RegExp(regexStr, 'g');
    return url.replaceAll(regex, function (match) { return replacements[match] || match; });
};
exports.resolveUrl = resolveUrl;
